import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sidebar-nav" }
const _hoisted_2 = { class: "nav-list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "nav-label" }

import { ref, onMounted, onUnmounted } from 'vue'
import { useSmoothScroll } from '@/composables/useSmoothScroll'


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarNav',
  setup(__props) {

const { scrollToId } = useSmoothScroll()
const activeId = ref('')
const showPaperLink = ref(false)

const navItems = [
  { id: 'overview', label: 'Overview' },
  { id: 'about', label: 'About' },
  { id: 'use', label: 'Use LabOS' },
  { id: 'benchmark', label: 'Benchmark' },
  { id: 'leaderboard', label: 'Leaderboard' },
  { id: 'media', label: 'Media' },
  { id: 'team', label: 'Team' }
]

let observer: IntersectionObserver | null = null
let footerObserver: IntersectionObserver | null = null

  onMounted(() => {
    // Main scroll handler for active section detection
    const handleScroll = () => {
      const scrollY = window.scrollY
      const viewportHeight = window.innerHeight
      const viewportMiddle = scrollY + viewportHeight / 2
      
      // Handle top "Overview" vs "About" logic
      if (scrollY <= 10) {
        activeId.value = 'overview'
        return
      }
      
      // Check footer first for Paper link
      const footerEl = document.getElementById('footer')
      if (footerEl) {
        const footerRect = footerEl.getBoundingClientRect()
        const footerVisible = footerRect.top < viewportHeight && footerRect.bottom > 0
        const footerVisibleRatio = footerVisible 
          ? Math.min((viewportHeight - footerRect.top) / viewportHeight, 1) 
          : 0
        
        showPaperLink.value = footerVisibleRatio >= 0.1
        
        // Switch to Paper when footer occupies 20% or more
        if (footerVisibleRatio >= 0.2) {
          activeId.value = 'paper'
          return
        }
      }
      
      // Find which section's content is near the middle of viewport
      let closestSection = 'about'
      let closestDistance = Infinity
      
      navItems.forEach((item) => {
        const el = document.getElementById(item.id)
        if (!el) return
        
        const rect = el.getBoundingClientRect()
        const elementTop = scrollY + rect.top
        const elementBottom = scrollY + rect.bottom
        
        // Check if viewport middle is within this section
        if (viewportMiddle >= elementTop && viewportMiddle <= elementBottom) {
          closestSection = item.id
          closestDistance = 0
          return
        }
        
        // Calculate distance from viewport middle to section
        const distanceToTop = Math.abs(viewportMiddle - elementTop)
        const distanceToBottom = Math.abs(viewportMiddle - elementBottom)
        const distance = Math.min(distanceToTop, distanceToBottom)
        
        if (distance < closestDistance) {
          closestDistance = distance
          closestSection = item.id
        }
      })
      
      activeId.value = closestSection
    }
    
    window.addEventListener('scroll', handleScroll, { passive: true })
    window.addEventListener('resize', handleScroll, { passive: true })
    
    // Initial check
    setTimeout(handleScroll, 100)

    // Store cleanup for unmount
    ;(window as any)._labosScrollHandler = handleScroll
  })

  onUnmounted(() => {
    const handler = (window as any)._labosScrollHandler
    if (handler) {
      window.removeEventListener('scroll', handler)
      window.removeEventListener('resize', handler)
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
        return _createElementVNode("div", {
          key: item.id,
          class: _normalizeClass(["nav-item", { active: activeId.value === item.id }]),
          onClick: ($event: any) => (_unref(scrollToId)(item.id))
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "nav-indicator" }, null, -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(item.label), 1)
        ], 10, _hoisted_3)
      }), 64)),
      _createVNode(_Transition, { name: "fade-slide" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("a", {
            class: _normalizeClass(["nav-item paper-link", { active: activeId.value === 'paper' }]),
            href: "https://arxiv.org/abs/2510.14861",
            target: "_blank",
            rel: "noopener"
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "nav-indicator" }, null, -1),
            _createElementVNode("span", { class: "nav-label" }, "Paper ↗", -1)
          ]))], 2), [
            [_vShow, showPaperLink.value]
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})